<template>
    <div id="superChallengeInfoPage" :class="'popupPage anim'+ ( open ? ' open' : '' )">
        <div v-if="open" class="container h-100">
            <div class="row h-100">
                <div class="col-md-6 h-100 m-auto">
                    <div class="header mb-3">
                        <h3 class="m-auto">{{ $t('super_ch.info_popup_title') }}</h3>
                        <a @click.prevent="open = false;btnSfx();" href="#" class="close"></a>
                    </div>

                    <div class="d-flex justify-content-center mb-3">
                        <img src="/images/home/super_challenges/house-sm.png" class="vh-10" />
                    </div>

                    <div class="text-justify mb-3" v-html="$t('super_ch.info_popup_text')"></div>

                    <h4 class="text-orange text-center mb-3">{{ $t('super_ch.info_popup_motivation') }}</h4>
                    <div class="text-center"> 
                        <p v-html="$t('super_ch.info_popup_footer')"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'

const SuperChallengeInfoPopup = Vue.component('super-challenge-info-popup', {
    data() {
        return {
            open: false
        }
    },
    methods:{
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        },  
    },
    watch: {
        open(){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.body.scrollTop = 0; // For Safari
            if(this.open) document.body.classList.add("lock");
            else document.body.classList.remove("lock");
        }
    }
})

export default SuperChallengeInfoPopup
</script>